import {
  FaChartPie,
  FaCoins,
  FaHandHoldingUsd,
  FaLayerGroup,
  FaTrophy,
  FaGlobe,
  FaUniversity,
  FaWallet,
  FaFileInvoiceDollar,
  FaExchangeAlt,
  FaHistory,
  FaUsers,
  FaListUl,
  FaUserFriends,
  FaRobot,
  FaHeadset,
  FaBullhorn,
  FaChartLine,
  FaCogs,
  FaUserShield,
} from "react-icons/fa";

const iconStyle = { color: "#749df5", fontSize: "1.25rem" };

export const all_Data = [
  {
    id: 2,
    navLink: "/admindashboard",
    navItem: "Dashboard",
    navIcon: (
      <span>
        <FaChartPie style={iconStyle} />
      </span>
    ),
    subcomponent: [],
  },
  {
    id: 3,
    navLink: "/masterConfig",
    navItem: "Master Config",
    navIcon: (
      <span>
        <FaCogs style={iconStyle} />
      </span>
    ),
    subcomponent: [],
  },

  {
    id: 6,
    navLink: "/directBonus",
    navItem: "Investment Income",
    navIcon: (
      <span>
        <FaWallet style={iconStyle} />
      </span>
    ),
    subcomponent: [
      {
        id: 6.1,
        navLink: "/directBonus",
        navItem: "Direct Income",
        navIcon: (
          <span>
            <FaHandHoldingUsd style={iconStyle} />
          </span>
        ),
      },
      {
        id: 6.2,
        navLink: "/roiBonus",
        navItem: "Trading Income",
        navIcon: (
          <span>
            <FaChartLine style={iconStyle} />
          </span>
        ),
      },
      {
        id: 6.3,
        navLink: "/levelBonus",
        navItem: "Trading Level Income",
        navIcon: (
          <span>
            <FaLayerGroup style={iconStyle} />
          </span>
        ),
      },
      {
        id: 6.4,
        navLink: "/salaryBonus",
        navItem: "Salary Bonus",
        navIcon: (
          <span>
            <FaTrophy style={iconStyle} />
          </span>
        ),
      },
      {
        id: 6.5,
        navLink: "/rewardBonus",
        navItem: "Reward Bonus",
        navIcon: (
          <span>
            <FaGlobe style={iconStyle} />
          </span>
        ),
      },
    ],
  },

  {
    id: 6.6,
    navLink: "/subscriptionLevelBonus",
    navItem: "Subscription Income",
    navIcon: (
      <span>
        <FaCoins style={iconStyle} />
      </span>
    ),
    subcomponent: [
      {
        id: 6.61,
        navLink: "/subscriptionDirect",
        navItem: "Subscription Referral",
        navIcon: (
          <span>
            <FaChartLine style={iconStyle} />
          </span>
        ),
      },
      {
        id: 6.62,
        navLink: "/subscriptionLevelBonus",
        navItem: "Subscription Level Income",
        navIcon: (
          <span>
            <FaLayerGroup style={iconStyle} />
          </span>
        ),
      },
      {
        id: 6.63,
        navLink: "/subscriptionRewardBonus",
        navItem: "Subscription Reward Bonus",
        navIcon: (
          <span>
            <FaGlobe style={iconStyle} />
          </span>
        ),
      },
    ],
  },

  {
    id: 7,
    navLink: "/topup",
    navItem: "Fund Management",
    navIcon: (
      <span>
        <FaUniversity style={iconStyle} />
      </span>
    ),
    subcomponent: [
      {
        id: 7.4,
        navLink: "/topup",
        navItem: "Member Topup",
        navIcon: (
          <span>
            <FaCoins style={iconStyle} />
          </span>
        ),
      },
      {
        id: 7.3,
        navLink: "/payoutReport",
        navItem: "Withdrawal Report",
        navIcon: (
          <span>
            <FaFileInvoiceDollar style={iconStyle} />
          </span>
        ),
      },
      {
        id: 7.5,
        navLink: "/fundTransferHistory",
        navItem: "Fund Transfer History",
        navIcon: (
          <span>
            <FaExchangeAlt style={iconStyle} />
          </span>
        ),
      },
      {
        id: 7.6,
        navLink: "/topupHistory",
        navItem: "Member Topup History",
        navIcon: (
          <span>
            <FaHistory style={iconStyle} />
          </span>
        ),
      },
      {
        id: 7.6,
        navLink: "/p2pTransferHistory",
        navItem: "P2P Transfer History",
        navIcon: (
          <span>
            <FaExchangeAlt style={iconStyle} />
          </span>
        ),
      },
    ],
  },

  {
    id: 8,
    navLink: "/memberList",
    navItem: "Member & Team",
    navIcon: (
      <span>
        <FaUsers style={iconStyle} />
      </span>
    ),
    subcomponent: [
      {
        id: 8.1,
        navLink: "/memberList",
        navItem: "Member List",
        navIcon: (
          <span>
            <FaListUl style={iconStyle} />
          </span>
        ),
      },
      {
        id: 8.2,
        navLink: "/teamAndMembers",
        navItem: "Team Members",
        navIcon: (
          <span>
            <FaUserFriends style={iconStyle} />
          </span>
        ),
      },
    ],
  },

  {
    id: 9,
    navLink: "/trade_pairs",
    navItem: "Trade & Pairs",
    navIcon: (
      <span>
        <FaRobot style={iconStyle} />
      </span>
    ),
    subcomponent: [],
  },

  {
    id: 10,
    navLink: "/tickets",
    navItem: "Ticket & Support",
    navIcon: (
      <span>
        <FaHeadset style={iconStyle} />
      </span>
    ),
    subcomponent: [],
  },

  {
    id: 11,
    navLink: "/newsAnnouncement",
    navItem: "News & Announcement",
    navIcon: (
      <span>
        <FaBullhorn style={iconStyle} />
      </span>
    ),
    subcomponent: [],
  },

  // {
  //   id: 12,
  //   navLink: "/update-trade-profit",
  //   navItem: "Update Trade Profit",
  //   navIcon: <span><FaChartLine style={iconStyle} /></span>,
  //   subcomponent: [],
  // },
  // {
  //   id: 13,
  //   navLink: "/subadmin-permission",
  //   navItem: "Admin Permission",
  //   navIcon: <span><FaUserShield style={iconStyle} /></span>,
  //   subcomponent: [],
  // },
];
